<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZhAYuX/tc-custom/9781398490475.jpg?1705539895631" alt="This image is the cover for the book A Raven's Calling"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Raven's Calling
      </h1>
      <p class="bookDescription body article font2">
        <p>This story begins in the small village of Louisbourg, Nova-Scotia and finds its way to the village of Perce, Quebec, where Celine brings the truth to light. We have a man, Tomas, found dead, washed up on a lonely beach and a woman, Celine, who comes from afar to begin a new life miles away in the historical village of Louisbourg. What do these two lives have in common? When Celine leaves her life of over fifty years in Ontario, to start a new chapter for herself she finds the truth about Tomas and how and why he was found, dead, on a beach many miles away from Louisbourg where he worked as a night watchman at the fortress of Louisbourg. Celine, his replacement, finishes what Tomas had begun until his mysterious death. Now the truth is in the hands of two countries. What will come from this new truth? Will history be rewritten? Was a life given up for love or truth?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ginette Therrien
      </h2>
      
      <p class="authorDescription body article">Ginette is a French-Canadian woman who is past middle age by a few years, but very young at heart. She sees beauty all around her with a love of animals which surpasses her tolerance of people most of the time. Ginette lives along the rugged Atlantic coast in a small Acadian village in Nova-Scotia. She is also the author of the book Three Titles: A Trifecta of Novellas.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?365afaa5